import { useEffect, useState } from 'react';

type ScreenOrientation = 'portrait' | 'landscape';

export const useMobileScreen = (
  minKeyboardHeight: number = 200,
  defaultOpen: boolean = false,
  defaultOrientation: ScreenOrientation = 'portrait'
) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(defaultOpen);
  const [screenOrientation, setScreenOrientation] = useState<ScreenOrientation>(
    defaultOrientation
  );

  useEffect(() => {
    const softkeyboardListener = () => {
      const newState =
        window.outerHeight - minKeyboardHeight >
        (window.visualViewport?.height || 0);

      if (isKeyboardOpen !== newState) {
        setIsKeyboardOpen(newState);
      }

      setScreenOrientation(
        window.outerHeight > window.outerWidth ? 'portrait' : 'landscape'
      );
    };
    if (typeof visualViewport !== 'undefined') {
      window.visualViewport?.addEventListener('resize', softkeyboardListener);
    }
    return () => {
      if (typeof visualViewport !== 'undefined') {
        window.visualViewport?.removeEventListener(
          'resize',
          softkeyboardListener
        );
      }
    };
  }, [isKeyboardOpen, minKeyboardHeight]);

  return { isKeyboardOpen, screenOrientation };
};
